import React, {useState, useEffect } from "react";
import 'regenerator-runtime/runtime';
import Moment from 'moment';

import history from '../../history';
import Ecg from '../Ecg';
import DiagnosticSelect from '../DiagnosticSelect';
import ExamComparator from '../Components/ExamComparator';
import SpinnerLoader from '../Components/SpinnerLoader';
import useMousetrap from "react-hook-mousetrap"
/*
* Authentication
*/
import Alt from 'alt';
import axios from 'axios';
import AuthActions from '../../actions/AuthActions';
import AuthStore from '../../stores/AuthStore';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import Constants from '../../Components/Constants'

import {
  ButtonToggle,
  Alert,
  Badge,
  Container,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardHeader,
  CardBlock,
  CardFooter,
  CardTitle,
  Button,
  Label,
  Input,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Media, InputGroup, InputGroupAddon
} from "reactstrap";

import classnames from "classnames";
import EcgPanel from '../EcgPanel';
import Widget02 from '../Widgets/Widget02';
import AlertContainer from 'react-alert';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default function ExamViewer(props) {
	
	const [isLoading, setIsLoading] = useState(true);
    const [isListEmpty, setIsListEmpty] = useState(true);
    const [now, setNow] = useState(new Date());
    
	const [examList, setExamList] = useState([]);
    const [currentExamPos, setCurrentExamPos] = useState(0);
	const [examId, setExamId] = useState(props.match === null ? null : props.match.params.examId);
	const [exam, setExam] = useState({});
	const [derivations, setDerivations] = useState([]);
	const [selectedDerivation, setSelectedDerivation] = useState(null);
	const [reportText, setReportText] = useState("");
    const [repetir, setRepetir] = useState(false);
	const [diagnostics, setDiagnostics] = useState([]);
	const [measurementsData, setMeasurementsData] = useState({
                HR: 0, RR: 0, PR: 0, T: 0, QRS: 0, QT: 0, Q: 0, P: 0, PQ: 0, QTc: 0, ST: 0, R1: 0, R2: 0,S: 0, R3: 0,R4: 0
    });
	const [isMarcacoesOpen, setIsMarcacoesOpen] = useState(false);
	const [marks, setMarks] = useState([]);
	
	const [gainZoom, setGainZoom] = useState(1);
	const [timeZoom, setTimeZoom] = useState(1);
	
	const [derivationNames, setDerivationNames] = useState(["I", "II", "III", "aVR", "aVL", "aVF", "V1", "V2", "V3", "V4", "V5", "V6"]);
	const [equipamentStartFromInit, setSquipamentStartFromInit] = useState({
      "EQUIPMENT_AEROTEL": 1,
      "EQUIPMENT_TEB": 0,
      "EQUIPMENT_CARDIOWEB_SERVER": 1,
      "EQUIPMENT_CARDIOWEB_CLIENT": 1,
      "EQUIPMENT_PHYSIO_GLOVE": 0,
      "EQUIPMENT_MICROMED_600": 1,
      "EQUIPMENT_MICROMED_300": 1,
      "EQUIPMENT_EPEOPLE": 1,
      "EQUIPMENT_VENTRIX": 1,
      "EQUIPMENT_BIONET_CARDIOXP": 0
    });
	const [searchFilter, setSearchFilter] = useState({
      firstResult: 0,
      maxResults: 100,

      reportStatus: "0",
      examRegister: "",
      clientName: "",
      patientName: "",
      beginExecutionDate: "",
      endExecutionDate: "",
      beginReceptionDate: "",
      endReceptionDate: "",
      beginReportDate: "",
      endReportDate: "",
      pediatricOnly: false,
      reportSearchText: "",
      genericSearchText: "",
      lowPriorityOnly: false,
      excludeLowPriorityExams: false
    });

    const onMeasurementChange = e => {
        const { name, value } = e.target;
        setMeasurementsData(prevState => ({
            ...prevState,
            [name]: parseFloat(value)
        }));
    };
    
    useMousetrap("ctrl+b", () => {
		toogleReportStatus();
	});
    
	useEffect(() => {
        if(props.match !== null && props.match.params.examId != null){
            setCurrentExam(props.match.params.examId);
        }
        updateExamList();
	}, []);
	
	useEffect(() => {
		const interval = setInterval(() => {
			 updateExamList();
             setNow(new Date())
		}, 3000);
		return () => clearInterval(interval);
	}, [examList, examId]);
    
    useEffect(() => {
		const statusInterval = setInterval(() => {
            if(examId != null){
                checkStatus();
            }
		}, 2000);
		return () => clearInterval(statusInterval);
	}, [examId,exam]);
		
    async function updateExamList(){
        await axios({
            method: 'post',
            url: Constants.apiUrl+'/api/v1/exam/doctor/light/'+AuthStore.getState().user.entity_id,
            data: searchFilter
        })
        .then(response => {
            //Se a lista estiver vazia, carrega o primeiro exame 
            if(isListEmpty && response.data.length > 0 && examId == null){
                setCurrentExam(response.data[0].id);
                setCurrentExamPos(0);
                setIsListEmpty(false);
            }else{
                let pos = 0;
                response.data.map(function(e, i){
                    if(e.id == examId){
                        pos = i;
                    }
                });

                setCurrentExamPos(pos);

                if( examId == null ){
                    setIsListEmpty(!(response.data.length > 0));
                }
            }

            setExamList(response.data);
        });
    }
    
    useEffect(() => {
        automaticStartReport();
        
        let repetirText = "Repetir exame devido a ";
        if(repetir){
            if(reportText.indexOf("Repetir exame devido a") == -1){
                setReportText(prev => repetirText+prev);
            }
        }else{
            setReportText(prev => prev.replace(repetirText, ""));
        }
	}, [repetir, reportText]);
    
    async function checkStatus(){
        if(exam.status != 'EXAM_STATUS_REPORTED'){
            await axios({
              method: 'get',
              url: Constants.apiUrl+'/api/v1/exam/checkStatus/'+examId
            })
            .then(response => {
               if(exam != {} && exam != null && exam.status  != 'EXAM_STATUS_REPORTED' && response.data.status != exam.status){
                   let newStatus = response.data.status;
                   setExam(prevState => ({
                        ...prevState,
                        'status': newStatus
                    }));
               }
            });
        }    
    }
    
	function setCurrentExam(id) {
        setIsListEmpty(false);
        setReportText("");
		axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/exam/'+id
        })
        .then(response => {
            let amostras = response.data.ecgData.split(',');
            let nAmostras = amostras.length / 12;
            let derivations = new Array(12);

            for (let x = 0; x < 12; x++) {
              derivations[x] = new Array(nAmostras);
            }

            for (let i = 0; i < amostras.length; i++) {
                let d = parseInt(i % 12);
                let pos = parseInt(i / 12);

                derivations[d][pos] = amostras[i];
            }

            setDerivations(derivations);
            setExamId(id);
			setExam(response.data);
			setIsLoading(false);
            
			if(response.data.status == 'EXAM_STATUS_REPORTED' || response.data.status == 'EXAM_STATUS_PREREPORTED'){
				setReportText(response.data.report);

              let tokens = response.data.measurements!= null ? response.data.measurements.split(',') : [];

              let examMeasurements = {
                HR: typeof tokens[1] == 'undefined' ? 0 : parseFloat(tokens[1].substr(tokens[1].indexOf('=')+1, tokens[1].length - tokens[1].indexOf('='))),
                RR: typeof tokens[4] == 'undefined' ? 0 :parseFloat(tokens[4].substr(tokens[4].indexOf('=')+1, tokens[4].length - tokens[4].indexOf('='))),
                PR: typeof tokens[12] == 'undefined' ? 0 :parseFloat(tokens[12].substr(tokens[12].indexOf('=')+1, tokens[12].length - tokens[12].indexOf('='))),
                T: typeof tokens[5] == 'undefined' ? 0 :parseFloat(tokens[5].substr(tokens[5].indexOf('=')+1, tokens[5].length - tokens[5].indexOf('='))),
                QRS: typeof tokens[6] == 'undefined' ? 0 :parseFloat(tokens[6].substr(tokens[6].indexOf('=')+1, tokens[6].length - tokens[6].indexOf('='))),
                QT: typeof tokens[10] == 'undefined' ? 0 :parseFloat(tokens[10].substr(tokens[10].indexOf('=')+1, tokens[10].length - tokens[10].indexOf('='))),
                Q: typeof tokens[8] == 'undefined' ? 0 :parseFloat(tokens[8].substr(tokens[8].indexOf('=')+1, tokens[8].length - tokens[8].indexOf('='))),
                P: typeof tokens[9] == 'undefined' ? 0 :parseFloat(tokens[9].substr(tokens[9].indexOf('=')+1, tokens[9].length - tokens[9].indexOf('='))),
                PQ: typeof tokens[11] == 'undefined' ? 0 :parseFloat(tokens[11].substr(tokens[11].indexOf('=')+1, tokens[11].length - tokens[11].indexOf('='))),
                QTc: typeof tokens[3] == 'undefined' ? 0 :parseFloat(tokens[3].substr(tokens[3].indexOf('=')+1, tokens[3].length - tokens[3].indexOf('='))),
                ST: typeof tokens[7] == 'undefined' ? 0 :parseFloat(tokens[7].substr(tokens[7].indexOf('=')+1, tokens[7].length - tokens[7].indexOf('='))),
                R1: typeof tokens[2] == 'undefined' ? 0 :parseFloat(tokens[2].substr(tokens[2].indexOf('=')+1, tokens[2].length - tokens[2].indexOf('='))),
                R2: typeof tokens[13] == 'undefined' ? 0 :parseFloat(tokens[13].substr(tokens[13].indexOf('=')+1, tokens[13].length - tokens[13].indexOf('='))),
                S: typeof tokens[14] == 'undefined' ? 0 :parseFloat(tokens[14].substr(tokens[14].indexOf('=')+1, tokens[14].length - tokens[14].indexOf('='))),
                R3: typeof tokens[15] == 'undefined' ? 0 :parseFloat(tokens[15].substr(tokens[15].indexOf('=')+1, tokens[15].length - tokens[15].indexOf('='))),
                R4: typeof tokens[16] == 'undefined' ? 0 :parseFloat(tokens[16].substr(tokens[16].indexOf('=')+1, tokens[16].length - tokens[16].indexOf('=')))
              };

              setMarks({
                P: examMeasurements.P,
                Q: examMeasurements.Q,
                R1: examMeasurements.R1,
                R2: examMeasurements.R2,
                R3: examMeasurements.R3,
                R4: examMeasurements.R4,
                S: examMeasurements.S,
                ST: examMeasurements.ST,
                T: examMeasurements.T
              });
                
              setMeasurementsData(examMeasurements);

            }
        });
	}
	
    async function resetForm(){
       await setIsLoading(true);
	   await setExamList([]);
	   await setExam({});
	   await setDerivations([]);
	   await setSelectedDerivation(null);
	   await setReportText("");
	   await setDiagnostics([]);
	   await setMeasurementsData(null);
	   await setIsMarcacoesOpen(false);
	   await setMarks([]);
	   await setGainZoom(1);
	   await setTimeZoom(1);
       await setExamId(null);
    }
    
    async function startReport(){
        await axios({
            method: 'post',
            url: Constants.apiUrl+'/api/v1/exam/status?examId='+examId+
            '&newStatus=EXAM_STATUS_WAITING_REPORT'+
            '&doctorId='+AuthStore.getState().user.entity_id+
            '&doctorName='+AuthStore.getState().user.entity_name
        })
        .then(response => {
            let id = AuthStore.getState().user.entity_id;
            let name = AuthStore.getState().user.entity_name;
            
            let tempExam = exam;
            tempExam.status = "EXAM_STATUS_WAITING_REPORT";
            tempExam.doctor =  {'id': id, 'name': name};
            
            setExam(tempExam);
        });
    }
    
	async function cancelReport(){
      let newStatus = "EXAM_STATUS_SENT_TO_REPORT";
      let doctorId = "";
      let doctorName = "";
        
      //Se exame era pré-laudado, volta ao status EXAM_STATUS_PREREPORTED e volta ao médico residente que executou o pré-laudo
      if(exam.preReport){
        newStatus = "EXAM_STATUS_PREREPORTED";
        doctorId = exam.preReport.doctor.id;
        doctorName = exam.preReport.doctor.name;
      }

      //Cancela laudo - Seta exame como 'AGUARDANDO LAUDO'
      await axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/status?examId='+examId+
            '&newStatus='+newStatus+
            '&doctorId='+doctorId+
            '&doctorName='+doctorName
      })
      .then(response => {
        let tempExam = exam;
        tempExam.status = "EXAM_STATUS_SENT_TO_REPORT";
        tempExam.doctor = null;
        tempExam.preReport = null;
        
        setExam(tempExam);
      });
    }

    function cancelAndLoadNextExam(){
        if(examList.length > 0){
            cancelReport().then(r => {
                updateExamList().then(v => {
                    resetForm().then(r2 =>{
                        if(examList.length > 0){
                            let pos = examList.length > (currentExamPos+1) ? currentExamPos+1 : 0;
                            let nextExam = examList[pos];

                            setExamId(nextExam.id);
                            setCurrentExam(nextExam.id);
                            setCurrentExamPos(pos);
                        }
                    });
                });
            });
        }
    }
    
    function loadNextExam(){
        
        updateExamList().then(v => {
            resetForm().then(r2 =>{
                if(examList.length > 0){
                    let pos = examList.length > (currentExamPos+1) ? currentExamPos+1 : 0;
                    let nextExam = examList[pos];

                    if(nextExam.status == "EXAM_STATUS_REPORTED" || nextExam.status == "EXAM_STATUS_WAITING_REPORT"){
                        setIsLoading(false);
                        setIsListEmpty(true);
                        setExamList([]);
                        resetForm();
                    }else{
                        setExamId(nextExam.id);
                        setCurrentExam(nextExam.id);
                        setCurrentExamPos(pos);
                    }
                    
                }else{
                    setIsLoading(false);
                    setIsListEmpty(true);
                }
            });
        });
    }
    
    function getNextPatient(){
        let pos = examList.length > (currentExamPos+1) ? currentExamPos+1 : 0;
        return examList[pos];
    }
    
    function repeatExam(opt){
        let tempExam = {...exam};
        tempExam.status = 'EXAM_STATUS_REPORTED';
        tempExam.ecgData = null;
        tempExam.dtReportEnd = new Date();
        tempExam.doctor = {"id": AuthStore.getState().user.entity_id, "name": AuthStore.getState().user.entity_name};
        tempExam.repeatExam = true;
        
        if(opt == "CI"){
            tempExam.report = "Repetir exame devido a cabos invertidos.";
        }
        if(opt == "AR"){
            tempExam.report = "Repetir exame devido a artefatos.";
        }
        
        axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/',
          data: tempExam
          })
          .then(response => {
            //Bug - carrega o mesmo exame, async
            if(examList.lenght == 1 && examList[0].id == tempExam.id){
                
            }else{
                loadNextExam();
            }
              
        });
    }
    
    function applyShortcutReport(code){
        
        setIsLoading(true);
        setExamList([]);
        setIsListEmpty(true);
        setExamId(null);
        
        let tempExam = exam;
        tempExam.status = 'EXAM_STATUS_REPORTED';
        tempExam.ecgData = null;
        tempExam.dtReportEnd = new Date();
        tempExam.doctor = {"id": AuthStore.getState().user.entity_id, "name": AuthStore.getState().user.entity_name};
        tempExam.repeatExam = true;
        
        if(code == "DLN"){
            tempExam.report = "Eletrocardiograma dentro dos limites da normalidade.";
            tempExam.normal = true;
        }
        if(code == "ARV"){
            tempExam.report = "Alterações difusas da repolarização ventricular.";
            tempExam.normal = false;
        }
        if(code == "AFC"){
            tempExam.report = "Atraso final de condução.";
            tempExam.normal = false;
        }
        
        axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/',
          data: tempExam
          })
          .then(response => {;
                if(examList.length == 1 && examList[0].id == tempExam.id){
                    resetForm();
                }else{                    
                    loadNextExam();
                }
        });
       
    }

	function sendReport(){
      setIsLoading(true);
      setExamList([]);
      setIsListEmpty(true);
      setExamId(null);
        
	  let examReport = {...exam};
        
      //Marca exame como Laudado
      examReport.status = 'EXAM_STATUS_REPORTED';

      //Remove o ECGDATA por questões de performance
      examReport.ecgData = null;

      examReport.dtReportEnd = new Date();
      examReport.report = reportText;
	  
      examReport.doctor = {"id": AuthStore.getState().user.entity_id, "name": AuthStore.getState().user.entity_name};
      examReport.diagnostics = diagnostics;
      examReport.repeatExam = repetir;
      //Gera string das marcações
      //EX:
      //{trace=V6, HR=53, R1=750.0, QTc=6, RR=1125, T=930.0, QRS=75, ST=0, Q=715.0, P=625.0, QT=215, PQ=90, PR=125, R2=1500.0, S=790.0, R3=2250.0}

      let measurementsStr = "";
      
	  if(measurementsData != null){
        measurementsStr += "{";
          measurementsStr += "trace="+derivationNames[selectedDerivation]+",";
          measurementsStr += "HR="+measurementsData.HR+", ";
          measurementsStr += "R1="+measurementsData.R1+", ";
          measurementsStr += "QTc="+measurementsData.QTc+", ";
          measurementsStr += "RR="+measurementsData.RR+", ";
          measurementsStr += "T="+measurementsData.T+", ";
          measurementsStr += "QRS="+measurementsData.QRS+", ";
          measurementsStr += "ST="+measurementsData.ST+", ";
          measurementsStr += "Q="+measurementsData.Q+", ";
          measurementsStr += "P="+measurementsData.P+", ";
          measurementsStr += "QT="+measurementsData.QT+", ";
          measurementsStr += "PQ="+measurementsData.PQ+", ";
          measurementsStr += "PR="+measurementsData.PR+", ";
          measurementsStr += "R2="+measurementsData.R2+", ";
          measurementsStr += "S="+measurementsData.S+", ";
          measurementsStr += "R3="+measurementsData.R3+", ";
          measurementsStr += "R4="+measurementsData.R4;
        measurementsStr += "}";
      }
	
      examReport.measurements = measurementsStr;

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/',
          data: examReport
      })
      .then(response => {
          if(examList.length == 1 && examList[0].id == tempExam.id){
                resetForm();
            }else{                    
                loadNextExam();
            }
        });
    }
	
	function changeReportText(evt){
		setReportText(evt.target.value);
	}
    
    function toogleReportStatus(){
        if(exam.status == 'EXAM_STATUS_WAITING_REPORT' && (exam.doctor == null || exam.doctor.id != AuthStore.getState().user.entity_id)){
            //Exame em laudo por outro médico
            
            confirmAlert({
                title: 'Exame em laudo',
                message: 'Exame em laudo por outro médico. Deseja concorrer ?',
                buttons: [
                    {
                      label: 'Sim',
                      onClick: () =>  startReport()
                    },
                    {
                      label: 'Não',
                      onClick: () => {}
                    }
                ]
            });
        }else{
            
            if(exam.status == 'EXAM_STATUS_WAITING_REPORT' && exam.doctor != null && exam.doctor.id == AuthStore.getState().user.entity_id){
                cancelReport();
            }else{
                startReport();
            }
        }
    }
    
    function automaticStartReport(){
        if(exam.status == 'EXAM_STATUS_SENT_TO_REPORT'){
            startReport();
        }
    }
	
	function onDerivationClick(derivation){
        //Apenas médicos devem avançar para a tela de marcações e diagnósticos
      if (AuthStore.getState().user.profile != "M") return;
      
	  derivation = derivation-1;

      //Se exame estiver laudado, não busca sugestão de marcações - usa-se as que foram definidas pelo médico.
      if(exam.status == "EXAM_STATUS_REPORTED"){
        
        return;
      }
      if(exam.status == "EXAM_STATUS_PREREPORTED"){
        setSelectedDerivation(derivation);
		setIsMarcacoesOpen(true);
        return;
      }
        
      automaticStartReport();

      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/exam/'+examId+'/ecg/'+derivation+'/marks'
      })
      .then(response => {
        setSelectedDerivation(derivation);
        setMarks(response.data);
		setIsMarcacoesOpen(true);
      });
	}
    
    function getAge(dateString){
      let today = new Date();
      let birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
      {
          age--;
      }
      return age;
    }
	
	return (
		<div className="h-100">
		{(isLoading || isListEmpty) ? (
         <div>
            <h4 className={"text-center w-100 "+(isListEmpty ? "" : "hidden")}>Nenhum exame na fila. Aguardando...</h4>
            <h6 className={"text-center w-100 "+(isListEmpty ? "" : "hidden")}>Atualizado pela última vez em {Moment(now).format('HH:mm:ss')}</h6>
            <div className={(isListEmpty ? "hidden" : "")}>
			     <SpinnerLoader />
            </div>
         </div>
		) : (
        
		<div className="h-100 container-flex">
		<Row className="exam-viewer-header p-0 small-txt">

		<Col xs="12" sm="4" md="2" className="p-1">
            {exam.status != 'EXAM_STATUS_REPORTED' ? 
			<Media>
				<Media left>
					<Button color={exam.status == 'EXAM_STATUS_WAITING_REPORT' ? "danger" : "success"} onClick={toogleReportStatus} 
                                className="rounded float-right w-100 h-100"><i className={"text-white " + (exam.status == 'EXAM_STATUS_WAITING_REPORT' ? "fa fa-lock" : "fa fa-unlock")}></i></Button>
				</Media>
				<Media body className="padding-left">
					<Media heading className="media-heading-examinfo">
						{exam.status == 'EXAM_STATUS_WAITING_REPORT' && exam.doctor != null ? <div><b>Em laudo por</b><br /> {exam.doctor.name}</div>: null}
                        {exam.status == 'EXAM_STATUS_SENT_TO_REPORT' ? <div>Aguardando Laudo</div>: null}
					</Media>
					
				</Media>
			</Media>
            : <div><b>Laudado por</b> <br />{exam.doctor != null ? exam.doctor.name : "-"}</div> }
		</Col>

		<Col xs="12" sm="4" md="4" className="p-1">
			<Media>
				<Media left>
					<span className="fa-stack fa-md">
						<i className={"fa fa-square fa-stack-2x " + (exam.patient.gender == "FEMALE" ? "text-danger " : "text-primary ")}></i>
						<i className={(exam.patient.gender == "FEMALE" ? "fa fa-female " : "fa fa-male ") + " fa-stack-1x fa-inverse"}></i>
					</span>
				</Media>
				<Media body className="padding-left">
					<Media heading className={"media-heading-examinfo "+ (exam.patient.gender == "FEMALE" ? "text-danger " : "text-primary ")}>
						{exam.patient.firstname +' '+exam.patient.lastname}
					</Media>
					<span>{exam.patient.gender == "FEMALE" ? "Feminino" : "Masculino"}</span>
				</Media>
			</Media>
		</Col>

		<Col xs="12" sm="4" md="2" className="p-1">
			<Media>
				<Media left>
					<span className="fa-stack fa-md">
						<i className="fa fa-square fa-stack-2x text-warning"></i>
						<i className="fa fa-calendar fa-stack-1x fa-inverse"></i>
					</span>
				</Media>
				<Media body className="padding-left">
					<Media heading className="media-heading-examinfo text-warning">
						{getAge(exam.patient.dtBirthDate) + " anos"}
					</Media>
					<span>Idade</span>
				</Media>
			</Media>
		</Col>

		<Col xs="12" sm="4" md="2" onClick={cancelAndLoadNextExam} className="clickable p-1">
			<b>Próximo Paciente</b>
            <br />
            {examList.length > 1 ? getNextPatient().patientFullName : '-'}
		</Col>

        <Col xs="12" sm="4" md="2" className="p-1">
			<b>Exames na Fila</b>
            <br />
            {examList.length > 0 ? examList.length -1 : 0} exames
		</Col>

		</Row>
		
		<Row className="flex-fill">
			<Col xs="12" sm="12" md="3">
				<div className={exam.status == 'EXAM_STATUS_REPORTED' || AuthStore.getState().user.profile != "M" ? 'hidden' : ''}>
					<DiagnosticSelect onReportChange={(diagnostics, reportText) => {
						setReportText(reportText);
						setDiagnostics(diagnostics);
						}}
                        preSelected={exam.status == 'EXAM_STATUS_PREREPORTED' ? exam.diagnostics : null}/>
				</div>	

                <div className={exam.status == 'EXAM_STATUS_REPORTED' ? '' : 'hidden'}>
                    <table>
                        <tbody>
                        <tr>
                            <td><b>HR (bpm)</b></td>
                            <td>{measurementsData != null ? measurementsData.HR.toFixed(2) : ''}</td>
                        </tr>
                        <tr>
                            <td><b>RR (ms)</b></td>
                            <td>{measurementsData != null ? measurementsData.RR.toFixed(2) : ''}</td>
                        </tr>
                        <tr>
                            <td><b>PR (ms)</b></td>
                            <td>{measurementsData != null ? measurementsData.PR.toFixed(2) : ''}</td>
                        </tr>
                        <tr>
                            <td><b>QRS (ms)</b></td>
                            <td>{measurementsData != null ? measurementsData.QRS.toFixed(2) : ''}</td>
                        </tr>
                        <tr>
                            <td><b>QT (ms)</b></td>
                            <td>{measurementsData != null ? measurementsData.QT.toFixed(2) : ''}</td>
                        </tr>
                        <tr>
                            <td><b>QTc (ms)</b></td>
                            <td>{measurementsData != null ? measurementsData.QTc.toFixed(2) : ''}</td>
                        </tr>
                        <tr>
                            <td><b>ST (mm)</b></td>
                            <td>{measurementsData != null ? measurementsData.ST.toFixed(2) : ''}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
			</Col>
			
			<Col xs="12" sm="12" md="3" className={exam.status != 'EXAM_STATUS_REPORTED' && AuthStore.getState().user.profile != "M" ? 'hidden' : ''}>
				<Row>
					<Col xs="12" sm="12" md="12">
						<Input type="textarea" disabled={exam.status == 'EXAM_STATUS_REPORTED'}
							value={reportText} onChange={changeReportText} rows={20}/>
					</Col>
				
                    <Col xs="12" sm="12" md="12">
                        <Button color="danger" onClick={() => {startReport().then( v => {applyShortcutReport("DLN");}); }} className="m-1">DLN</Button>
                        <Button color="danger" onClick={() => {startReport().then( v => {applyShortcutReport("ARV");}); }} className="m-1">ARV</Button>
                        <Button color="danger" onClick={() => {startReport().then( v => {applyShortcutReport("AFC");}); }} className="m-1">AFC</Button>

                        <Button color="warning" className="m-1 text-white" active={repetir} onClick={() => {setRepetir(!repetir)}}>Repetir</Button>

                        <Button color="primary" onClick={sendReport} className="m-1 text-white w-100">Enviar Laudo</Button>
                    </Col>
				</Row>
			</Col>
			
			<Col xs="12" sm="12" md={exam.status != 'EXAM_STATUS_REPORTED' && AuthStore.getState().user.profile != "M" ? "12" : "6"}>
				
				<div className={isMarcacoesOpen ? 'hidden' : ' '}>
                    <EcgPanel derivations={derivations} onDerivationClick={onDerivationClick}
                      ecgSampleRate={exam == null ? 0 : exam.ecgSampleRate} ecgResolution={exam == null ? 0 : exam.ecgResolution}
                      startFromInit={equipamentStartFromInit[exam.client.equipmentType]}/>
				</div> 
				
				<Row className={(isMarcacoesOpen ? ' ' : ' hidden')}>
					<Col xs="12" sm="12" md="12">
                      <Row className="text-center text-small">
                        <Col xs="12" md="6">
                            <Label className="stext-small">Ganho ({(gainZoom * 0.25).toFixed(2)}{'\u00A0'}mm/mv)</Label>
                            <Button color="primary" id={"gain-zoom-up-ecg-laudo"} size="sm" className="m-1 small-bt"
                                onClick={() => {setGainZoom(gainZoom *2);}}>+</Button>

                            <Button color="primary" id={"gain-zoom-down-ecg-laudo"} size="sm" className="m-1 small-bt"
                                onClick={() => {if(gainZoom > 1) setGainZoom(gainZoom / 2);}}>-</Button>
                        </Col>

                        <Col xs="12" md="6">
                            <Label className="stext-small">Tempo ({(timeZoom*6.25).toFixed(2)}{'\u00A0'} mm/s)</Label>

                            <Button color="success" id={"time-zoom-up-ecg-laudo"} size="sm" className="m-1 small-bt" 
                                onClick={() => {setTimeZoom(timeZoom *2);}}>+</Button>

                            <Button color="success" id={"time-zoom-down-ecg-laudo"} size="sm" className="m-1 small-bt"
                                onClick={() => {if(timeZoom > 1) setTimeZoom(timeZoom / 2);}}>-</Button>

                            <Button color="danger" size="sm" onClick={()=> {setIsMarcacoesOpen(false);}} className="float-right small-bt mt-1">Voltar</Button>
                        </Col>
                    </Row>
                    
                    <Row className="ecg-panel-row">
                        <Col xs="12" md="12" className="p-0 m-0">
                          <div className="large-ecg-container large-ecg-container-limited-height ecg-wrapper m-1">
                            <div className="large-ecg-inner-container ecg-dragscroll dragscroll">
                              <Ecg ecgData={derivations[selectedDerivation]} marks={marks}
                                  id="ecg-laudo" drawGrid={true} drawMarks={true}
                                  totalTime="10" displayTime="10" startFrom="0" ECGLineColor="#005500" traceName={derivationNames[selectedDerivation]} drawInnerGrid={true}
                                  onMeasurementChange={(measurementsData) => {

                                      setMeasurementsData(measurementsData);

                                       /**
                                       * Verifica a existencia do diagnóstico QT Longo, a partir das seguintes regras:
                                         * SEXO MASCULINO e QTc > 450
                                         * SEXO FEMININO e QTc > 470
                                         */

                                       let qtLongoDetected =
                                                    (exam.patient.gender == 'MALE' && measurementsData.QTc > 450) ||
                                                    (exam.patient.gender == 'FEMALE' && measurementsData.QTc > 470);

                                        let actualExam = exam;
                                        actualExam.qtLongoDetected = qtLongoDetected;

                                        setExam(actualExam);
                                  }}
                                  ecgSampleRate={exam == null ? 0 : exam.ecgSampleRate} ecgResolution={exam == null ? 0 : exam.ecgResolution}/>
                                </div>
                              </div>
                            </Col>
                        </Row>
                        </Col>

                        <Col xs="12" sm="12" md="12">
							<div className="text-small">
								<div className="float-left">
									<Label htmlFor="hr" className="p-0 m-1">HR (bpm)</Label>
									<Input type="number" name="HR" id="hr" bsSize="sm" value={measurementsData != null ? measurementsData.HR.toFixed(2) : ''} className="small-input limited-width m-1"
                                        onChange={onMeasurementChange}/>
									<br />
								</div>
								<div className="float-left">
									<Label htmlFor="rr" className="p-0 m-1">RR (ms)</Label>
									<Input type="number" id="rr" bsSize="sm" value={measurementsData != null ? measurementsData.RR.toFixed(2) : ''} className="small-input limited-width m-1"
                                        onChange={onMeasurementChange}/>
									<br />
								</div>
								<div className="float-left">
									<Label htmlFor="pr" className="p-0 m-1">PR (ms)</Label>
									<Input type="number" name="PR" id="pr" bsSize="sm" value={measurementsData != null ? measurementsData.PR.toFixed(2) : ''} className="small-input limited-width m-1"
                                        onChange={onMeasurementChange}/>
									<br />
								</div>
								<div className="float-left">
									<Label htmlFor="qrs" className="p-0 m-1">QRS (ms)</Label>
									<Input type="number" name="QRS" id="qrs" bsSize="sm" value={measurementsData != null ? measurementsData.QRS.toFixed(2) : ''} className="small-input limited-width m-1"
                                        onChange={onMeasurementChange}/>
									<br />
								</div>
								<div className="float-left">
									<Label htmlFor="qt" className="p-0 m-1">QT (ms)</Label>
									<Input type="number" name="QT" id="qt" bsSize="sm" value={measurementsData != null ? measurementsData.QT.toFixed(2) : ''} className="small-input limited-width m-1"
                                        onChange={onMeasurementChange}/>
									<br />
								</div>
								<div className="float-left">
									<Label htmlFor="qtc" className="p-0 m-1">QTc (ms)</Label>
									<Input type="number" name="QTc" id="qtc" bsSize="sm" value={measurementsData != null ? measurementsData.QTc.toFixed(2) : ''} className="small-input limited-width m-1"
                                        onChange={onMeasurementChange}/>
									<br />
								</div>
								<div className="float-left">
									<Label htmlFor="st" className="p-0 m-1">ST (mm)</Label>
									<Input type="number" name="ST" id="st" bsSize="sm" value={measurementsData != null ? measurementsData.ST.toFixed(2) : ''} className="small-input limited-width m-1"
                                        onChange={onMeasurementChange}/>
									<br />
								</div>
                            </div>
                        </Col>
                    </Row>
					
					  
				<Row className="m-1 small-txt">
					<Col xs="12" sm="12" md="6">
                        
				        <b>Exame:{' '}</b>
						<span>{exam.publicId}</span>
						<br />
                            
                        <b>Data de Recepção:{' '}</b>
						<span>{new Date(exam.dtReceived).getDate() +'/'+ (new Date(exam.dtReceived).getMonth()+1)+'/'+new Date(exam.dtReceived).getFullYear()}</span>
						<br />
                            
						<b>Nome:{' '}</b>
						<span>{exam.patient.firstname +' '+exam.patient.lastname}</span>
						<br />
						
						<b>Nome da Mãe:{' '}</b>
						<span>{exam.patient.motherName != "" ? exam.patient.motherName  : "-"} </span>
						<br />
						
						<b>Telefone:{' '}</b>
						<span>{exam.patient.contactPhone != "" ? exam.patient.contactPhone : "-"} </span>
						<br />
						
						<b>Documento:{' '}</b>
						<span>{exam.patient.document}</span>
						
						<div className={AuthStore.getState().user.profile != "M" ? 'hidden' : ''}>
							<ExamComparator exam={exam} derivations={derivations} />
						</div>	
					</Col>
					
					<Col xs="12" sm="12" md="6">
						 {exam.patientAntecedents != null && exam.patientAntecedents.length > 0 ?
							 <span>
							  <b>Antecedentes: {' '}</b>
							  {
								  exam.patientAntecedents.map(function(antecedent, i){
									return <span key={antecedent.id}>{(antecedent.description + ((i >= (exam.patientAntecedents.length -1)) ? '' : ','))}</span>;
									})
							  }
							  <br />
							</span>
							: ''
						}
						{exam.otherPatientAntecedents != null && exam.otherPatientAntecedents != "" ?
							<span>
							<b>Outros Antecedentes:{' '}</b>
							{exam.otherPatientAntecedents}
							<br />
							</span>
							: ''
						}
						
						
						{exam.patientSymptoms != null && exam.patientSymptoms.length > 0?
							<span>
							  <b>Sintomas:{' '}</b>
							  {
								exam.patientSymptoms.map(function(symptom, i){
									return <span key={symptom.id}>{(symptom.description + ((i >= (exam.patientSymptoms.length -1)) ? '' : ','))}</span>;
								})
							  }
							  <br />
							</span>
							: ''
						}
						
						{exam.otherPatientAntecedents != null && exam.otherPatientAntecedents != "" ?
							<span>
							<b>Outros Sintomas:{' '}</b>
							{exam.otherPatientSymptoms}
							<br />
							</span>
							: ''
						}
						
						<b>Observações:</b>
						<span> { exam.obs } </span>
						<br />
						
						<b>Saturação:</b>
						<span>{ exam.saturation} </span>
						<br />
						
						<b>Frequência:</b>
						<span>{ exam.frequency} </span>
						<br />
						
						<b>Pressão:</b>
						<span>{ exam.paSistolic+"/"+exam.paDiastolic} </span>
					</Col>
				</Row>
			</Col>
		</Row>
		</div>
		)}
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/views/ExamViewer/ExamViewer.js